package com.gsb.vyapar.bhagya.presentation.business.view

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.AppBarDefaults
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.material.FloatingActionButton
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Scaffold
import androidx.compose.material.Surface
import androidx.compose.material.Tab
import androidx.compose.material.TabRow
import androidx.compose.material.TabRowDefaults
import androidx.compose.material.TabRowDefaults.tabIndicatorOffset
import com.gsb.vyapar.bhagya.theme.add_icon
import androidx.compose.material.pullrefresh.pullRefresh
import androidx.compose.material.pullrefresh.rememberPullRefreshState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.isBusinessDeleted
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.business.util.getMBusinessUserUI
import com.gsb.vyapar.bhagya.presentation.business.util.launchAddEditMBusiness
import com.gsb.vyapar.bhagya.presentation.business.util.launchBusinessDetail
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.text.Text16Medium
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.theme.white
import org.jetbrains.compose.resources.painterResource

@Composable
fun ManageBusinessView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Scaffold(
            floatingActionButton = {
                FloatingActionButton(backgroundColor = primary, contentColor = white, onClick = {
                    launchAddEditMBusiness(Business())
                }) { Icon(painter = painterResource(add_icon), contentDescription = "add") }
            },
            modifier = Modifier.fillMaxSize()
        ) { paddingValues ->
            Column(
                modifier = Modifier.fillMaxWidth().padding(paddingValues)
            ) {
                Toolbar("Manage Business")
                TabView(uiState, onTriggerEvent)
            }
        }

    }
}

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun TabView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val tabs = listOf(
        TabItem("In Review"),
        TabItem("Approved"),
    )
    var selectedTabIndex by remember { mutableStateOf(getBusinessUiState().manageBusinessTab) }
    Column {
        TabRow(
            selectedTabIndex = selectedTabIndex,
            backgroundColor = primary,
            contentColor = white,
            indicator = { tabPositions ->
                TabRowDefaults.Indicator(
                    color = white,
                    modifier = Modifier
                        .tabIndicatorOffset(tabPositions[selectedTabIndex])
                        .fillMaxWidth()
                )
            },
            modifier = Modifier
                .shadow(AppBarDefaults.TopAppBarElevation)
                .zIndex(1f)
        ) {
            tabs.forEachIndexed { index, tab ->
                Tab(
                    selected = selectedTabIndex == index,
                    onClick = {
                        selectedTabIndex = index
                        getBusinessUiState().updateManageBusinessTab(index)
                    },
                    modifier = Modifier.padding(8.dp),
                    content = {
                        Row(horizontalArrangement = Arrangement.Center, verticalAlignment = Alignment.CenterVertically) {
                            Text16Medium(
                                text = tab.title,
                                modifier = Modifier.padding(8.dp),
                                color = if (selectedTabIndex == index) white else offwhite
                            )
                        }
                    }
                )
            }
        }
        when (selectedTabIndex) {
            0 -> {
                if (uiState.businessUiState.mBusinessList.isEmpty()) {
                    Column(Modifier.fillMaxSize().padding(8.dp), verticalArrangement = Arrangement.Center, horizontalAlignment = Alignment.CenterHorizontally) {
                        CommonImage(painterResource(splash), Modifier.width(150.dp).height(150.dp))
                        Spacer(Modifier.height(8.dp))
                        Text14RegularBB(text = "No Businesses in Review", color = black)
                        Spacer(Modifier.height(8.dp))
                        Text14RegularB(text = "You don’t have any businesses under review. Submit your business for approval!", color = black)
                    }
                } else {
                    val pullState = rememberPullRefreshState(
                        refreshing = uiState.businessUiState.isRefreshing,
                        onRefresh = {
                            getMBusinessUserUI()
                        },
                    )
                    LazyColumn(modifier = Modifier.pullRefresh(pullState, enabled = true).fillMaxWidth().padding(8.dp)) {
                        items(uiState.businessUiState.mBusinessList, key = { it.getId() }) { business ->
                            BusinessCardFull(uiState, onTriggerEvent, business) {
                                launchAddEditMBusiness(business)
                            }
                            Spacer(Modifier.height(8.dp))
                        }
                    }
                }
            }
            1 -> {
                if (uiState.businessUiState.myBusinessList.isEmpty()) {
                    Column(Modifier.fillMaxSize().padding(8.dp), verticalArrangement = Arrangement.Center, horizontalAlignment = Alignment.CenterHorizontally) {
                        CommonImage(painterResource(splash), Modifier.width(150.dp).height(150.dp))
                        Spacer(Modifier.height(8.dp))
                        Text14RegularBB(text = "No Approved Businesses", color = black)
                        Spacer(Modifier.height(8.dp))
                        Text14RegularB(text = "You don’t have any approved businesses yet. Start by adding one!", color = black)
                    }
                } else {
                    LazyColumn(modifier = Modifier.fillMaxWidth().padding(8.dp)) {
                        items(uiState.businessUiState.myBusinessList, key = { it.getId() }) { businessOld ->
                            val business = getBusinessUiState().isBusinessFetched.value[businessOld.getId()] ?: businessOld
                            if (!business.isBusinessDeleted()) {
                                BusinessCardFull(uiState, onTriggerEvent, business) {
                                    launchBusinessDetail(business)
                                }
                                Spacer(Modifier.height(8.dp))
                            }
                        }
                    }
                }
            }
        }
    }
    LaunchedEffect(Unit) {
        if (getBusinessUiState().loadReviewBusiness) {
            getMBusinessUserUI()
            getBusinessUiState().updateLoadReviewBusiness(false)
        }
        getBusinessUiState().updateManageBusinessTab(selectedTabIndex)
        getBusinessUiState().updateMyBusinessList()
    }
}

data class TabItem(val title:String)